export const FILTER_BASICS="BASICS";
export const FILTER_CUSTOM_FIELDS="CUSTOM_FIELDS";
export const FILTER_PRINT_MAIL="PRINT_MAIL";
export const FILTER_ENTRANCES = "ENTRANCES";
export const FILTER_REGISTRATION_WAY = "REGISTRATION_WAY";
export const FILTER_DAYS = "DAYS";
const BASE_SHOWN_FILTERS = {
    BASICS: false,
    CUSTOM_FIELDS: false,
    PRINT_MAIL: false,
    ENTRANCES: false,
    WEB_CHANNEL_FIELDS: false,
    DAYS: false,
}
export default function filterUser(
    state = {
        openFilter: true,
        filterData: null,
        filtered: false,
        reloadUserData: false,
        shownFilters: [FILTER_BASICS],
        filterVisible: []
    },
    action
) {
    switch (action.type) {
        case "SET_FILTER_USER_ALL":
            return {...state, openFilter: action.openFilter, filterData: action.filterData, filtered: action.filtered}
        case "SET_OPEN_FILTER":

            if(action.openFilter === false){
                return {...state, openFilter: action.openFilter,filterVisible: []}
            }else{
                return {...state, openFilter: action.openFilter,filterVisible: state.shownFilters}
            }
        case "SET_FILTER_DATA":
            return {...state, filterData: action.filterData}
        case "SET_FILTERED":
            return {...state, filtered: action.filtered}
        case "SET_RELOAD_ACCREDITATION":
            return {...state, reloadUserData: action.reloadUserData}
        case "SET_SHOWN_FILTERS":
            let shown = setShownFilters(state, action.shownFilters);
            return {...state, shownFilters: shown,openFilter: true}
        case "DELETE_SHOWN_FILTER":
            let shownFilters = state.shownFilters.filter(filter => filter !== action.filter);
            return {...state, shownFilters: shownFilters}
        case "SET_FILTER_VISIBLE":
            const current = state.filterVisible ?? [];
            let newFilterVisible;
            if (!current.includes(action.filter)) {
                newFilterVisible = [...current, action.filter];
            } else {
                newFilterVisible = current.filter(f => f !== action.filter);
            }
            return {
                ...state,
                filterVisible: newFilterVisible
            };
        case "HIDE_ALL_FILTERS":
            return {
                ...state,
                filterVisible: []
            }
        case "SHOW_ALL_FILTERS":
            return {
                ...state,
                filterVisible: [...state.shownFilters]
            }
        case "RESET_FILTER_USER":
        case "RESET":
            return {
                openFilter: true,
                filterData: null,
                filtered: false,
                reloadUserData: false,
                shownFilters: state.shownFilters?state.shownFilters:[FILTER_BASICS],
                filterVisible: state.filterVisible?state.filterVisible:[]
            }
        default:
            return state;
    }
}


const setShownFilters = (state, shownFilters) => {
    let shown = [];
    if(shownFilters[FILTER_BASICS])
        shown.push(FILTER_BASICS);
    if(shownFilters[FILTER_CUSTOM_FIELDS])
        shown.push(FILTER_CUSTOM_FIELDS);
    if(shownFilters[FILTER_PRINT_MAIL])
        shown.push(FILTER_PRINT_MAIL);
    if(shownFilters[FILTER_ENTRANCES])
        shown.push(FILTER_ENTRANCES);
    if(shownFilters[FILTER_REGISTRATION_WAY])
        shown.push(FILTER_REGISTRATION_WAY);
    if(shownFilters[FILTER_DAYS])
        shown.push(FILTER_DAYS);
    return shown;
}

export const getShownFilters = (state) => {
    let filters = {...BASE_SHOWN_FILTERS};
    if(state.shownFilters) {
        state.shownFilters.forEach(filter => {
            filters[filter] = true;
        })
    }

    return filters;
}
